/* eslint-disable */
export default {
  download: 'Descargar',
} as const;

// @key: @#@"download"@#@ @source: @#@"Download"@#@
